// Projects.js

import React from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { ProjectCard } from './ProjectCard';
import Testimonials from './Testimonials'; // Import the Testimonials component
import projImg1 from '../assets/img/project-img1.png';
import projImg2 from '../assets/img/project-img2.png';
import projImg3 from '../assets/img/project-img3.png';
import projImg4 from '../assets/img/project-img4.png';
import projImg5 from '../assets/img/project-img5.png';
import projImg6 from '../assets/img/project-img6.png';
import colorSharp2 from '../assets/img/color-sharp2.png';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
  const projects = [
    {
      title: 'The Worm Herder',
      description:
        'For The Worm Herder, I harnessed PHP, MySQL, HTML, and Tailwind CSS. Leveraging PHP and MySQL, I implemented robust backend functionality. HTML structured the frontend, and Tailwind CSS facilitated styling. This endeavor showcased my ability to integrate diverse technologies for a dynamic and functional web application.',
      imgUrl: projImg1,
      link: 'https://thewormherdersa.com/',
    },
    {
      title: 'The ManneQuin Incident',
      description:
        'In The ManneQuin Incident, I delved into the realm of game development using Unreal Engine, C++, and state machines. This project challenged me to navigate the intricacies of game logic, implement functionality in C++, and manage state transitions effectively. It served as a valuable learning experience in the realm of game development and coding with Unreal Engine.',
      imgUrl: projImg2,
      link: 'https://tdw1.itch.io/the-mannequinn-incident/',
    },
    {
      title: 'The Gericht Website',
      description:
        'In building the Gericht website, I used React, HTML, Tailwind CSS, and JavaScript to create a user-friendly and visually appealing site. With React, I organized components efficiently, Tailwind CSS simplified styling, and JavaScript added interactive elements. This project reflects my approach to blending design and functionality for a seamless web experience.',
      imgUrl: projImg3,
      link: 'http://ww1.gericht-restaurant.com/',
    },
    {
      title: 'Nike Website',
      description:
        'For the Nike Website project, I independently crafted the entire web application. Utilizing JavaScript, I implemented interactive features, ensuring a smooth user experience. CSS was employed for styling, enhancing the visual appeal, while HTML formed the backbone for content structuring. This project showcased my ability to work solo, utilizing JavaScript, CSS, and HTML to create a dynamic and visually pleasing website.',
      imgUrl: projImg5,
      link: 'https://nike-landing-page-theta-blond.vercel.app/',

    },
    {
      title: 'NOX',
      description:
        'Collaborated with one teammate on the NOX game project. My role included utilizing C# for gameplay mechanics, Fmod for immersive audio, ShaderLab/HLSL for captivating visuals, and Objective C++ for seamless platform integration. Demonstrated proficiency in multiple technologies for a comprehensive gaming experience.',
      imgUrl: projImg4,
      link: 'https://itch.io/jam/boss-rush-jam-2024/rate/2511144',
    },
    {
      title: 'Blog Website',
      description:
        'For the Blog, I successfully implemented a fully functional blogging platform. Leveraging Next.js for a robust React-based front end and MongoDB for a dynamic and scalable database, the app seamlessly handles blog creation, editing, and deletion. The project demonstrates my proficiency in building full-stack applications, combining the power of Next.js with MongoDB to deliver a feature-rich and efficient blogging experience.',
      imgUrl: projImg6,
      link: 'https://thewormherdersa.com/',
      githubLink: ''
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeIn' : ''}>
                  <h2>Projects</h2>
                  <p>
                  Dive into my projects, each telling a story of my journey in web development and beyond. Crafting intuitive interfaces, exploring game development, and creating engaging websites are just a few chapters of my ongoing adventure.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Tab 1</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? 'animate__animated animate__slideInUp' : ''}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Testimonials /> {Testimonials}
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>.</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background"></img>
    </section>
  );
};

export default Projects;

